import { render, staticRenderFns } from "./find-password.vue?vue&type=template&id=4cb440aa&scoped=true&"
import script from "./find-password.vue?vue&type=script&lang=js&"
export * from "./find-password.vue?vue&type=script&lang=js&"
import style0 from "./find-password.vue?vue&type=style&index=0&id=4cb440aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb440aa",
  null
  
)

export default component.exports